import { hydrate } from 'svelte'
import createThirdPartyStores from '../stores/createThirdPartyStores'

// import Leaderboard from '../../components/UC-leaderboard.svelte'
import ThirdPartyTable from '../../components/composite/dag/3rdPartyTable.svelte'

/**
 * Fetch data for Stakeholders page; mount its components
 */
export async function buildThirdParty() {
  const [
    data, // the main store; will hold ALL data fetched
    loading, // will be true until the data fetching is done, can be used in components for loading state
    error, // if the fetches went completely sideways, this will be truthy, and can be used in components
    
    thirdPartyTableStore,
  ] = await createThirdPartyStores()

  const tableDOM = document.getElementById('third-party-table')
  if(tableDOM) {
    hydrate(ThirdPartyTable, {
      target: tableDOM,
      props: {
        tableData: thirdPartyTableStore,
        loading,
        error,
      }
    })
  }
}